export let executionEntries = {
  bindings: {
    activity: '<',
    text: '<'
  },
  template: `
    <p  
      class="m-sm pointer text-azul text-sm close-text text-block" 
      ng-click="vm.executionEntries(vm.activity)">
        {{vm.text}}
    </p>`,
  controllerAs: 'vm',
  controller: ['WorkPlanModalSrv', 
  function executionEntriesCtrl (WorkPlanModalSrv) {
  // constants
    const vm = this

  // methods
    vm.executionEntries = executionEntries

    function executionEntries (activity) {
      let parentActivity = activity
      parentActivity.selectedActivityId = activity.workplanTeacherActivityId
      WorkPlanModalSrv.setVariable(parentActivity)
      WorkPlanModalSrv.executionEntries()
    }
  }
]}




// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/modals/execution-entries.js